export default class PeriodicPvrService {
	constructor(apiService) {
		this.apiService = apiService
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('periodicPvrs/' + id, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/PeriodicPvrService.js